"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_property_decorator_1 = require("vue-property-decorator");
const debounce_1 = require("@common/tsutils/debounce");
const trans_1 = require("@common/tsutils/trans");
let StatsCard = class StatsCard extends vue_property_decorator_1.Vue {
    constructor() {
        super(...arguments);
        this.title = '';
        this.search = '';
        this.ph = (0, trans_1.trans)('toolkit.search_micro');
        this.mwms = this.cluster.mwms;
    }
    get _uid() {
        return Math.random();
    }
    mounted() {
        this.update_title();
    }
    onChangeCluster() {
        this.update_title();
        this.mwms = this.cluster.mwms;
        this.search = '';
    }
    update_title() {
        const title = (0, trans_1.trans)('toolkit.coocurrence.organisms_representing_in', {
            stat: (0, trans_1.trans)('toolkit.coocurrence.' + this.type),
            cluster: this.cluster.name,
        });
        this.title = title;
    }
    onSearch() {
        let mwms = this.cluster.mwms;
        const search = this.search.trim().toLowerCase();
        if (search) {
            mwms = mwms.filter(mwm => {
                return mwm.genus.toLowerCase().includes(search) ||
                    mwm.species.toLowerCase().includes(search) ||
                    (0, trans_1.trans)('mwm.' + mwm.typechar).toLowerCase().includes(search);
            });
        }
        this.mwms = mwms;
    }
};
__decorate([
    (0, vue_property_decorator_1.Prop)()
], StatsCard.prototype, "cluster", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)()
], StatsCard.prototype, "type", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)()
], StatsCard.prototype, "active", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('cluster')
], StatsCard.prototype, "onChangeCluster", null);
__decorate([
    (0, vue_property_decorator_1.Watch)('search'),
    (0, debounce_1.PerInstanceDebounce)(100)
], StatsCard.prototype, "onSearch", null);
StatsCard = __decorate([
    (0, vue_property_decorator_1.Options)({
        components: {}
    })
], StatsCard);
exports.default = StatsCard;
